<svg width="12px" height="12px" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="iconify iconify--twemoji" preserveAspectRatio="xMidYMid meet">
  <circle fill="#DD2E44" cx="18" cy="18" r="18"></circle>
</svg>
